import { journey_vehicleService } from '../_services';

const state = { onRequest: false, journey_vehicle: [] };

const actions = {
    get_data({ dispatch, commit }, data) {
        commit('request');

        journey_vehicleService.get_data(data)
            .then(
                resp => {
                    commit('success_data', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    clear_data({ commit }) {
        commit('clear_data');
    },
};
const getters = {
  onRequest: state => {
    return state.onRequest
  },
  journey_vehicle: state => {
    return state.journey_vehicle
  },
};

const mutations = {
    request(state) {
        state.onRequest = true;
        state.journey_vehicle = [];
    },
    success(state) {
      state.onRequest = false;
    },
    success_data(state, data) {
      state.onRequest = false;
      state.journey_vehicle = data;
    },
    clear_data(state) {
      state.onRequest = false;
      state.journey_vehicle = [];
    },
    error(state) {
        state.onRequest = false;
    },
};

export const journey_vehicles = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
